import { render } from "./ActionLink.vue?vue&type=template&id=7992b956"
import script from "./ActionLink.vue?vue&type=script&lang=js"
export * from "./ActionLink.vue?vue&type=script&lang=js"

import exportComponent from "/opt/goodtoknow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__